import { createContext, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router";

const AuthContext = createContext({auth: false, url: '/api/public'});

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState(false);

  let navigate = useNavigate();

    useEffect(() => {
      fetch('/api/loggedIn')
          .then(res => res.json())
          .then(r => {
              setAuth(r);
          })
          .catch(e => console.error(e));
    }, [navigate]);

  return (
    <AuthContext.Provider value={{auth: auth, url: auth? '/api': '/api/public'}}>
      {children}
    </AuthContext.Provider>
  )
};

export const useAuth = () => useContext(AuthContext);